module.exports = __webpack_public_path__ + "db680de5c994999217b8195f4fbfdbbe.svg";